import { useState } from 'react';
import api from '../Services/api';
import endpointsAdmin from '../Services/endpointAdmin';

/**
 * Hook untuk update riwayat pengajuan
 * @returns { Object } - Mengembalikan fungsi updateRiwayatPengajuan, serta status loading dan error.
 */
const useUpdateRiwayatPengajuan = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fungsi untuk memperbarui data riwayat pengajuan di backend.
   * @param { number } id_pengajuan - ID riwayat pengajuan
   * @param { Object } data - Data yang akan diupdate (misal: { status: 'DISETUJUI' })
   * @returns { Promise<Object> } - Mengembalikan data respons dari backend atau error.
   */
  const updateRiwayatPengajuan = async (id_pengajuan, data) => {
    setLoading(true);
    setError(null);

    try {
      if (!id_pengajuan) {
        throw new Error('ID pengajuan tidak ditemukan');
      }

      if (!endpointsAdmin.riwayat_pengajuan || typeof endpointsAdmin.riwayat_pengajuan.update !== 'function') {
        throw new Error('Endpoint riwayat_pengajuan.update tidak terdefinisi');
      }

      const updateUrl = endpointsAdmin.riwayat_pengajuan.update(id_pengajuan);
      console.log('Updating riwayat pengajuan:', { id: id_pengajuan, url: updateUrl, payload: data });

      const response = await api.put(updateUrl, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('Update response:', response.data);
      return response.data;
    } catch (err) {
      console.error('Error updating riwayat pengajuan:', err);
      const errorMsg = err.response?.data?.message || err.response?.data?.error || err.message || 'Terjadi kesalahan saat memperbarui data';
      setError(errorMsg);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { updateRiwayatPengajuan, loading, error };
};

export default useUpdateRiwayatPengajuan;
